import {
  GET_STUDENTS,
  SET_PAGE,
  SET_SEARCH,
  SET_SORT_BY,
  SET_ORDER_BY,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initialStudents = {
  students: [],
  studentCount: 0,
  page: 1,
  search: "",
  orderby: "desc",
  sortby: "",
};

const studentsReducer = (state = initialStudents, action) => {
  switch (action.type) {
    case GET_STUDENTS:
      return {
        ...state,
        students: action.payload.students.map((student) => {
          return {
            ...student,
            professionalProfile:
              student.professionalProfileId?.professionalProfileName,
            updatedAtFormatted: moment(student.createdAt).format("ll"),
          };
        }),
        studentCount: action.payload.totalCount,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default studentsReducer;
